export { SalaryCalculator } from './SalaryCalculator';
export type { NetPayInfo } from './SalaryCalculator';
